<template>
  <div class="member">
    <fixed-header class="member__header" title="会员购买"></fixed-header>
    <div class="member-main scroll-touch">
      <div class="member__info">
        <div :class="['member__info-card', 'vip-' + vipType]">
          <div class="member__info-card-user">
            <img
                :src="vipInfo.headPicL"
                class="member__info-card-user-avatar"
            />
            <div class="member__info-card-user-info">
              <p class="member__info-card-user-info-name">
                {{ vipInfo.nickname }}<span>{{ getVipType() }}</span>
              </p>
              <p v-if="vipType === 2" class="member__info-card-user-info-time">
                {{ vipInfo.vipEndTime }} 到期
              </p>
            </div>
          </div>
        </div>
        <img
            class="shdow"
            src="../../../assets/img/member/member_card_bottom_shadow_1.png"
        />
      </div>
      <div class="member__privilege">
        <p class="desc">开通商城会员</p>
        <p class="content stamp">尊享三大特权</p>
        <div class="member__privilege-list">
          <div class="member__privilege-list-item">
            <img src="../../../assets/img/member/member_shopping_icon.png"/>
            <p>购物特权</p>
          </div>
          <div class="member__privilege-list-item">
            <img src="../../../assets/img/member/member_coupon_right.png"/>
            <p>优惠券特权</p>
          </div>
          <div class="member__privilege-list-item">
            <img src="../../../assets/img/member/member_service_right.png"/>
            <p>服务特权</p>
          </div>
          <!--                <div class="member__privilege-list-item">-->
          <!--                    <img src="../../../assets/img/member/"/>-->
          <!--                    <p>生活特权</p>-->
          <!--                </div>-->
        </div>
        <div
            v-for="item in shopProductList"
            v-bind:key="item.productId"
            :mg-stat-lob="`productid=${item.productId}`"
            class="member__privilege-pay"
            mg-stat-click
            mg-stat-custom="cont=立即开通&label=btn&direct=cntp"
            mg-stat-mod="vip_open"
            @click="prePay(item.productId, item.shopPrice)"
        >
          {{ item.shopPrice }}元开通{{ item.productName }}
        </div>
        <div
            v-if="jointProductList && jointProductList.length"
            class="member__privilege-union"
        >
          <p class="stamp union">联合会员</p>
          <div class="member__privilege-union-group">
            <div
                v-for="item in jointProductList"
                v-bind:key="item.productId"
                class="member__privilege-union-group-item"
            >
              <img :src="item.productImg"/>
              <div class="desc">{{ item.productName }}</div>
              <div class="price">￥{{ item.shopPrice }}元</div>
              <button
                  :mg-stat-lob="`productid=${item.productId}`"
                  mg-stat-click
                  mg-stat-custom="cont=立即开通&label=btn&direct=cntp"
                  mg-stat-mod="vip_open"
                  @click="prePay(item.productId, item.shopPrice)"
              >
                立即开通
              </button>
            </div>
          </div>
        </div>
        <div class="member__privilege-mall">
          <p class="text stamp">商城会员权益</p>
          <div class="member__privilege-mall-group">
            <div class="item">
              <p class="title">专享购物特权</p>
              <div class="list">
                <img src="../../../assets/img/member/member_n_icon_2.png"/>
                <p>专享会员价</p>
              </div>
              <div class="list">
                <img src="../../../assets/img/member/member_n_icon_7.png"/>
                <p>专享秒杀</p>
              </div>
            </div>
            <div class="item">
              <p class="title">专享优惠券特权</p>
              <div class="list">
                <img src="../../../assets/img/member/member_n_icon_1.png"/>
                <p>代金券</p>
              </div>
              <div class="list">
                <img src="../../../assets/img/member/member_n_icon_5.png"/>
                <p>折扣券</p>
              </div>
            </div>
            <div class="item">
              <p class="title">专享服务特权</p>
              <div class="list">
                <img src="../../../assets/img/member/member_n_icon_3.png"/>
                <p>生日礼包</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Pay
        :isShow="isShowPay"
        :needGo="false"
        :orderId="orderId"
        :orderType="1"
        :originPage="originPage"
        :price="totalPrice"
        @changeVisible="(val) => (isShowPay = val)"
        @clickPay="uploadClose"
    ></Pay>
  </div>
</template>
<script>
import FixedHeader from 'components/common/FixedHeader';
import { setFixedParams, uploadCloseData } from 'utils/uploadData';
import * as VipApi from 'apis/member';
import DataStorage from 'utils/dataStore';
import Pay from 'components/common/Pay';

export default {
  components: { FixedHeader, Pay },
  data() {
    return {
      vipInfo: {},
      vipType: 0,
      vipdetail: { 0: '普通用户', 1: '视频会员', 2: '商城会员' },
      shopProductList: [], // 会员产品
      jointProductList: [], // 第三方联合会员
      isShowPay: false,
      originPage: this,
      orderId: null,
      totalPrice: null,
    };
  },
  async created() {
    await setFixedParams(this);
    // 获取会员产品
    this.getVipProducts();
  },
  methods: {
    async getVipProducts() {
      const products = await VipApi.products();
      if (products) {
        this.vipInfo = products.userInfo;
        this.vipType = products.userInfo.vipType;
        this.shopProductList = products.shopProductList;
        this.jointProductList = products.jointProductList;
      }
    },
    getVipType() {
      return this.vipdetail[this.vipType];
    },
    async prePay(productId, price) {
      let paramEntry = '';
      let paramFrom = '';
      const uploadParams = DataStorage.getFixedUploadParams();
      if (uploadParams) {
        paramEntry = uploadParams.entry;
        paramFrom = uploadParams.from;
      }
      try {
        const result = await VipApi.buy({
          productId,
          productNum: 1,
          fromOrigin: paramFrom,
          entry: paramEntry,
        });
        this.orderId = result.orderId;
        this.totalPrice = price;
        this.isShowPay = true;
      } catch (e) {
        this.$toast(`${e.message}`);
      }
    },
    async uploadClose(callback) {
      this.hasRouteChange = true; // 支付成功回来之后 路由会变化 但是支付的时候已经上报了  所以设置为true 不再上报
      await uploadCloseData();
      if (typeof callback === 'function') {
        callback();
      }
    },
  },
};
</script>
<style lang="scss">
.member__header {
  .fixed-header {
    color: #fff;
    background-color: unquote("#282323FF");

    section,
    button {
      padding-top: 0px !important;
    }

    .back-padding-top-new {
      padding-top: 12px !important;
    }

    i.icon.go_back {
      background-image: url("../../../assets/img/icon/go_back_white.png");
    }
  }

  .fixed-header__title {
    color: #fff;
  }
}
</style>
<style lang="scss" scoped>
.member {
  height: 100%;
  box-sizing: border-box;

  .stamp {
    background-image: url("../../../assets/img/member/member_pay_left.png"),
    url("../../../assets/img/member/member_pay_right.png");
    background-repeat: no-repeat, no-repeat;
    background-size: 102px 9px;
    background-position: 149px 20px, 499px 20px;
    text-align: center;
  }

  .union {
    background-position: 149px 20px, 433px 20px;
  }

  background-color: #fff;

  &-main {
    height: 100%;
    background-color: #fff;
  }

  &__info {
    height: 228px;
    width: 100%;
    background: unquote("#282323FF");
    background-size: 751px 31px;
    background-position-y: 199px;
    position: relative;
    overflow: hidden;

    .shdow {
      position: absolute;
      z-index: 999;
      bottom: -5px;
      left: 0px;
      width: 100%;
    }

    div {
      float: left;
      background-size: 100% 100%;
    }

    .vip-0 {
      background-image: url("../../../assets/img/member/member_card_normal.png");
    }

    .vip-1 {
      background-image: url("../../../assets/img/member/member_card_video.png");
    }

    .vip-2 {
      background-image: url("../../../assets/img/member/member_card_mall.png");
    }

    &-card {
      width: 670px;
      height: 322px;
      margin: 20px 0px 0px 40px;
      border-radius: 20px;
      position: relative;
      background-repeat: no-repeat;
      background-size: 100%, 100%;

      &-user {
        padding: 40px;

        &-avatar {
          width: 88px;
          height: 88px;
          background: rgba(255, 255, 255, 1);
          border-radius: 50%;
          float: left;
        }

        &-info {
          margin-left: 24px;

          &-name {
            font-size: 32px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(82, 55, 17, 1);
            line-height: 45px;
            margin-bottom: 9px;

            span {
              margin-left: 10px;
              padding: 2px 15px;
              font-size: 20px;
              color: rgba(255, 255, 255, 1);
              line-height: 28px;
              width: 100px;
              height: 29px;
              background: rgba(230, 177, 95, 1);
              border-radius: 15px;
            }
          }

          &-time {
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(82, 55, 17, 1);
            line-height: 33px;
          }
        }
      }
    }
  }

  &__privilege {
    margin-top: 10px;
    text-align: center;

    > p {
      font-size: 36px;
    }

    .desc {
      height: 37px;
      font-size: 26px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(229, 192, 131, 1);
      line-height: 37px;
    }

    > p.content {
      font-weight: 500;
      margin-top: 20px;
      font-size: 36px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: rgba(0, 0, 0, 1);
      line-height: 50px;
    }

    &-list {
      width: 100%;
      height: 200px;
      padding: 20px 85px;
      display: flex;
      justify-content: space-between;
      box-sizing: border-box;

      &-item {
        width: 160px;
        float: left;
        font-size: 24px;

        img {
          height: 120px;
          width: 120px;
        }

        p {
          font-size: 26px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(85, 85, 85, 1);
          line-height: 37px;
        }
      }
    }

    &-pay {
      margin: 10px 40px 20px 40px;
      box-sizing: border-box;
      height: 98px;
      width: 688px;
      line-height: 90px;
      border-radius: 10px;
      background-image: url("../../../assets/img/member/member_btn_bg.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      font-size: 32px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(82, 55, 17, 1);
    }

    &-union {
      padding: 10px 30px;

      .stamp {
        font-size: 36px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: rgba(0, 0, 0, 1);
        line-height: 50px;
        text-align: center;
      }

      &-group {
        margin-top: 32px;
        display: flex;
        justify-content: space-between;
        padding-bottom: 0px 60px;
        text-align: center;

        &-item {
          font-size: 30px;
          width: 303px;
          height: 376px;
          background: rgba(255, 255, 255, 1);
          box-shadow: 0px 3px 15px -3px rgba(0, 0, 0, 0.07);
          border-radius: 10px;

          img {
            height: 193px;
            width: 303px;
            line-height: 150px;
            border-top-right-radius: 10px;
            border-top-left-radius: 10px;
          }

          .desc {
            font-size: 22px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(211, 178, 128, 1);
            line-height: 30px;
            margin-bottom: 5px;
          }

          .price {
            font-size: 32px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: rgba(0, 0, 0, 1);
            line-height: 45px;
          }

          button {
            width: 220px;
            height: 60px;
            line-height: 60px;
            background-image: url("../../../assets/img/member/member_btn_bg_big.png");
            background-repeat: no-repeat;
            background-size: 100% 100%;
            font-size: 28px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(82, 55, 17, 1);
            margin-top: 16px;
          }
        }
      }
    }

    &-mall {
      height: 900px;

      .text {
        vertical-align: middle;
        font-size: 36px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: rgba(0, 0, 0, 1);
        line-height: 50px;
      }

      &-group {
        margin: 20px 24px;
        background: rgba(250, 250, 250, 1);
        border-radius: 10px;
        box-sizing: border-box;
        padding: 32px 24px;

        .item {
          width: 100%;
          position: relative;
          height: 220px;

          .title {
            font-size: 28px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(0, 0, 0, 1);
            line-height: 40px;
            text-align: left;
            text-indent: 15px;
          }

          .title:before {
            content: "";
            width: 6px;
            height: 24px;
            position: absolute;
            top: 7px;
            left: 0;
            background: rgba(186, 133, 69, 1);
          }

          .list {
            width: 140px;
            text-align: center;
            float: left;
            margin-right: 50px;

            img {
              margin-top: 10px;
              display: inline-block;
              width: 90px;
              height: 90px;
              border-radius: 50%;
            }

            p {
              font-size: 24px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(85, 85, 85, 1);
              line-height: 33px;
            }
          }
        }
      }
    }
  }
}
</style>
